


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { CollapsableItem } from '../../../models/CollapsableMenu';

@Component
export default class CollapsableCoursesSection extends Vue {
    @Prop() private item!: CollapsableItem;
    @Prop() private isLoading!: Boolean;
    private searchQuery: string = '';

    get availableCourses(): any[] {
        if (!this.item.items) return [];
        return this.item.items.filter(
            item => item.isCourse && item.title && item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }
    get displayedCourses(): any[] {
        return this.availableCourses.filter(item => item.status !== 'completed').slice(0, 5);
    }

    get numCourses(): number {
        return this.availableCourses.length;
    }

    get linkTitle(): string {
        if (!this.item.introLinkTitle) return '';
        return this.item.introLinkTitle.replace('{0}', this.numCourses.toString());
    }

    // The auto login link is created on demand, only when the user opens a course.
    // The window is opened synchronously to avoid popup blockers.
    private openCourse(subItem: any) {
        const win = window.open('', '_blank');
        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'get',
            url: '/api/everyday/learnifier/courselogin',
            params: { courseUrl: subItem.link },
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then((response: any) => {
                if (win) {
                    win.location.href = response.data;
                } else {
                    window.location.href = response.data;
                }
            })
            .catch((error: any) => {
                if (win) {
                    win.close();
                }
                console.error(error);
            });
    }

    private formatDuration(duration: string): string {
        return duration ? `${Number(duration)} min` : '';
    }

    private formatDate(date: string): string {
        return new Date(date).toISOString().split('T')[0];
    }
}
